

















































import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'join-us',
})
export default class JoinUs extends Vue { }
